package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class SyndromeIndicationSignSymptomRule(private val literal: String) : IEnumType {
	但见即是("但见即是"),
	但见即非("但见即非"),
	必见("必见"),
	可见("可见");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "syndrome_indication_sign_symptom_rule"}
	override fun getLiteral(): String {return literal}
}
